export interface IGetSuggestedPortfoliosResponse {
  wallets: IWallet[];
}

export interface IWallet {
  apiId: string;
  isSuggestedInvestment: boolean;
  name: string;
  redeemAt: string;
  rentability: string;
  volatility: string;
  risk: string;
}

export interface ICreateSuggestedPortfolioResponse {
  id: string;
  name: string;
}

export enum IRisk {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

export interface IGetSuggestedPortfolioDetailsResponse {
  categories: ICategorie[];
  details: IDetail[];
  goalDuration: string;
  initialInvestment: string;
  name: string;
}

export interface ICategorie {
  allocValue: IAllocValue;
  color: string;
  products: IProduct[];
  type: string;
}

export interface IProduct {
  allocValue: IAllocValue;
  name: string;
}

export interface IAllocValue {
  value: number;
  formatted: string;
}

export interface IDetail {
  label: string;
  value: string;
}
